import React from 'react';
import { Button,Navbar,Form,FormControl,Nav } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'

const HeaderMenu=(props)=>{
    let location = useLocation();
    let menus = [
      {href:"/v2/tin-tuc" ,title :'Tin Tức'},
      {href:"/v2/do-thi" ,title :'Đồ Thị'},
      {href:"/v2/danh-muc" ,title :'Danh Mục'},
      {href:"/v2/bao-cao-phan-tich" ,title :'Báo Cáo PT'},
      {href:"/v2/bao-cao-tai-chinh" ,title :'Báo Cáo TC'},
    ]
    menus.forEach(e=>e.isActive=location.pathname.indexOf(e.href)===0);
    return (
      <Navbar bg="light" expand="lg" >
        <Navbar.Brand href="/">SigmaStock</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {
              menus.map((e,i)=><Nav.Link key={i} href={e.href} active={e.isActive}  >{e.title}</Nav.Link>)
            }
          </Nav>
          <Form inline>
            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
            <Button variant="outline-success">Search</Button>
          </Form>
        </Navbar.Collapse>
      </Navbar>
    )
  }
export default HeaderMenu;